import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Agence from './pages/Agence';
import Metier from './pages/Metier';
import Projets from './pages/Projets';
import Innopath from './pages/Innopath';
import Recrutement from './pages/Recrutement';
import JobDetail from './pages/JobDetail';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Page404 from './pages/Page404';
import ExampleUsage from './components/ExampleUsage';
import { ContactModal, ContactProvider, CookieConsent } from './components';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import './assets/fonts.css';
import theme from './theme';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: var(--font-primary);
    font-weight: var(--font-weight-regular);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1a1a2e;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-primary);
    font-weight: var(--font-weight-semibold);
    line-height: 1.2;
  }

  button, input, select, textarea {
    font-family: var(--font-primary);
    font-weight: var(--font-weight-regular);
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
  
  strong, b {
    font-weight: var(--font-weight-semibold);
  }
  
  nav {
    font-weight: var(--font-weight-medium);
  }
`;

// Composant pour tracker les changements de page
const MatomoTracker: React.FC = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialisation de Matomo au premier chargement
    if (!window._paq) {
      window._paq = [];
      const u = "//matomo.tfapp.online/";
      window._paq.push(['requireConsent']);
      window._paq.push(['setTrackerUrl', u + 'matomo.php']);
      window._paq.push(['setSiteId', '6']);
      
      const script = document.createElement('script');
      script.async = true;
      script.src = u + 'matomo.js';
      document.head.appendChild(script);
    }
    
    // Tracker la vue de page à chaque changement de route
    const url = location.pathname + location.search + location.hash;
    window._paq.push(['setCustomUrl', url]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);
    
    console.log(`[Matomo] Tracking page view: ${url}`);
  }, [location]);
  
  return null;
};

// Composant séparé pour les routes avec le tracker Matomo
const AppRoutes: React.FC = () => {
  return (
    <>
      <MatomoTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agence" element={<Agence />} />
        <Route path="/metier" element={<Metier />} />
        <Route path="/projets" element={<Projets />} />
        <Route path="/innopath" element={<Innopath />} />
        <Route path="/recrutement" element={<Recrutement />} />
        <Route path="/talents" element={<Recrutement />} /> {/* Redirection pour compatibilité arrière */}
        <Route path="/job/:id" element={<JobDetail />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/examples" element={<ExampleUsage />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
};

const App: React.FC = () => {

  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <ContactProvider>
          <Router>
            <GlobalStyle />
            <AppRoutes />
            <ContactModal />
            <CookieConsent />
          </Router>
        </ContactProvider>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;